<!-- 出库申请列表 -->
<template>
  <div class='page_content'>
    <el-drawer id="drawerBox" :close-on-press-escape="true" :visible.sync="showAfterSales" :with-header="false" append-to-bodycustom-class="drawer_box" direction="ltr" size="100%">
      <improveAfterSalesInformationList v-if="showAfterSales" ref="improveAfterSalesInformationList" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData">
      </improveAfterSalesInformationList>
    </el-drawer>
    <div class="page_content_top">
      <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
      <div class="page_content_top_line">
        <v-search v-if="pageShowData.jurHead" :searchList="pageShowData.jurHead.jurconfigform" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
      </div>
    </div>
    <div class="page_content_center">
      <el-table v-if="pageShowData.jurTableVo" stripe :data="returnData.list" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" @selection-change="handleSelectionChange" highlight-current-row size="mini">
        <el-table-column type="selection" width="40">
        </el-table-column>
        <el-table-column v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable" :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight" :prop="tableValye.entityField"
          :label="tableValye.showField">
          <template slot-scope="scope">
            <span v-if="tableValye.fieldType == 'date'">
              <span v-if="scope.row[tableValye.entityField]">
                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
              </span>
            </span>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
              {{ scope.row.isWms == 0 ? '否' : '是' }}
            </el-tag>
            <!-- <span v-else-if="tableValye.entityField == 'wmId'">
              <a @click="toDetail(scope.row[tableValye.riftField], scope.row, 'querMoneysettlement')">{{scope.row[tableValye.entityField] }}</a>
            </span> -->
            <span v-else-if="tableValye.isRift == 1">
              <a @click="toDetail(scope.row[tableValye.riftField])">{{scope.row[tableValye.entityField] }}</a>
            </span>
            <el-tag size="mini" v-else-if="tableValye.entityField == 'woamState'">{{
                                    $common.getIsGsp(tableValye.formatterContent, scope.row.woamState) }}</el-tag>
            <span v-else-if="tableValye.fieldType == 'formatter'">{{
                                    $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</span>
            <span v-else>
              {{ scope.row[tableValye.entityField] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_content_bottom">
      <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
    </div>
    <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
      <SearchScheme ref="searchScheme" :id="seId" :smId="cmId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" />
    </el-dialog>
    <printPlan ref="printPlan"></printPlan>
    <!-- 自定义设计 -->
    <customDesign ref="customDesign"></customDesign>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import SearchScheme from "../../../byComponents/SearchScheme.vue"
import improveAfterSalesInformationList from "@/components/improveAfterSalesInformationList.vue";
export default {    //salesInstrumentOrderList
  //import引入的组件需要注入到对象中才能使用
  components: {
    SearchScheme,
    improveAfterSalesInformationList,
  },
  data() {
    //这里存放数据
    return {
      tableHeight: 0,
      getRequestData: {
        cmId: '', // 客户ID
        cmName: '', // 客户名称
        orderType: 1,  //	订单类型0.药品1.器械2出库申请
        page: 1,
        rows: 30,
        start: '', //开始上一个月
        end: '', //当天最后时间
      },
      returnData: {
        pages: 0, // 总页数
        total: 0, // 总条数
        pageNum: 0, // 当前页数
        list: []
      },
      sField: '',
      buttonList: [],
      pageShowData: [],
      formDataList: [],
      seTitle: "", //检索
      DialogVisible: false,
      seWidth: '0',
      seId: 0,
      cmId: 0,
      showAfterSales: false,
      actionData: {},
      parentSearchData: {},
      multipleSelection: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    'getRequestData.cmName': {
      handler: function (newValue, oldValue) {
        if (newValue == '') {
          this.getRequestData.cmId = ''
        }
      },
      deep: true,
    }
  },
  //方法集合
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 子组件触发
    drawerCancel() {
      this.showAfterSales = false
      this.getDataList()
    },
    // 点击穿透字段 传参单号
    toDetail(orderId, data, entityField) {
      if (orderId) {
        // 设置为true 打开穿透组件首页    
        var isPenetrate = true
        // 设置缓存 存入点击单号
        if (entityField == 'querMoneysettlement') {
          this.resetSetItem('penetrateOrderId', JSON.stringify({
            data,
            type: entityField
          }));

        } else {
          this.resetSetItem('penetrateOrderId', orderId);
        }
        // 与父级跨域通信 传递isPenetrate参数
        window.parent.postMessage({ //向窗口发送MessageEvent消息
          cmd: 'returnFormJson',
          params: {
            isPenetrate
          } //参数
        }, '*');
      }
    },
    // 检索Id, 索引(表格中), 标识
    openSearch({ sId, index, type, sField }) {
      this.DialogVisible = true
      this.seId = sId
      this.sField = sField
      this.parentSearchData[type] = this.getRequestData[type]
    },
    //检索带回数据
    changeInputModel(val) {
      if (val != "" || val != undefined) {
        this.DialogVisible = false;
        this.paramValue(val)
      }
    },
    // 赋值字段
    paramValue(val) {
      let arr = this.sField.split(',')
      arr.forEach(item => {
        this.getRequestData[item] = val[item]
      })
    },
    getSeWidth(e) {
      // console.log(e);
      this.seWidth = e + "%";
    },
    getWidth(e) {
      // console.log(e);
      this.exWidth = e + "%";
    },
    getSearchName(e) {
      // console.log(e);
      this.seTitle = e;
    },
    isShowData(name, value) {
      switch (name) {
        case 'customerList':
          var dataInfo = sessionStorage.getItem('selectCustomerData')
          if (dataInfo) {
            dataInfo = JSON.parse(dataInfo)
            this.getRequestData.cmId = dataInfo.cmId
            this.getRequestData.cmName = dataInfo.cmName
          }

          break;

        default:
          this.getRequestData[name] = value

      }
    },

    async getPageInfo() {
      var pathId = parent.getMenuInfo(this.$route.path)
      let responseData = await this.$http.getJur({
        ids: [pathId.jurId]
      })
      if (responseData.status == 200) {
        this.getButtonList()
        this.pageShowData = responseData.result
        this.formDataList = this.pageShowData.jurFormVoList
        var obj = {}
        if (this.pageShowData.jurHead) {
          obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
        } else {
          obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        }
        for (const key in obj) {
          this.$set(this.getRequestData, key, obj[key])
        }
        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },
    // 动作集合
    actionSet(actionData) {
      switch (actionData.actionType) {
        case 0:
          this.showAfterSales = true
          this.actionData = {
            cate: 0,
            formData: this.formDataList,
            oldData: {},
            orderId: '',
            printSouce: '',
            printJurId: '',
            type: 'one'
          }
          break;
        case 1:
          if (this.returnData.list.length <= 0) {
            this.$message({
              message: '暂无数据',
              type: 'error'
            });
            return false
          }
          if (this.multipleSelection.length != 1) {
            this.$message({
              message: "请先选中一条操作数据",
              type: "error",
            });
            return false;
          }
          if (this.multipleSelection[0].woamState != 0) {
            this.$message({
              message: "当前状态不可修改",
              type: "error",
            });
            return false;
          }
          this.showAfterSales = true;
          this.actionData = {
            cate: 1,
            formData: this.formDataList,
            oldData: this.multipleSelection[0],
            orderId: this.multipleSelection[0].woamId,
            printSouce: '',
            printJurId: '',
            type: 'one'
          }
          break;
        case 2:
          this.delDataAction()
          break;
        case 3:
          this.submitData()
          break;
        case 4:
          if (this.returnData.list.length <= 0) {
            this.$message({
              message: '暂无数据',
              type: 'error'
            });
            return false
          }
          if (this.multipleSelection.length != 1) {
            this.$message({
              message: "请先选中一条操作数据",
              type: "error",
            });
            return false;
          }
          console.log(this.multipleSelection);
          // if (!(this.multipleSelection[0].woamState >= 2 && this.multipleSelection[0].woamState < 4)) {
          //   this.$message({
          //     message: "当前状态不可完善售后信息",
          //     type: "error",
          //   });
          //   return false;
          // }
          this.showAfterSales = true
          this.actionData = {
            cate: 1,
            formData: this.formDataList,
            oldData: this.multipleSelection[0],
            orderId: this.multipleSelection[0].woamId,
            printSouce: '',
            printJurId: '',
            type: 'one'
          }
          break;
      }
    },
    openFormDesign() {
      let pathInfo = parent.getMenuInfo(this.$route.path)
      this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
    },
    showPrintPlan() {
      if (this.multipleSelection.length != 1) {
        this.$message({
          message: "请先选中一条操作数据",
          type: "error",
        });
        return false;
      }
      // 调用全局方法 判断Websocket是否连接
      if (this.$printSocketApi.printExeMsg() != false) {
        // 选中的数据
        var info = this.multipleSelection[0];
        this.$refs.printPlan.openDia(info.woamId);
      } else {
        return;
      }
    },//woamId
    // 提交审核
    async submitData() {
      if (this.returnData.list.length <= 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        });
        return false

      }
      var dataInfo = []
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请先选中要操作数据",
          type: "error",
        });
        return false;
      }
      var flag = false
      this.multipleSelection.forEach(item => {
        if (item.wmState != 0) {
          flag = true
        }
        dataInfo.push(item.wmId)
      })
      if (flag) {
        this.$message({
          message: "当前数据有不可提交状态",
          type: "error",
        });
        return
      }
      var delData = {
        ids: dataInfo
      }
      let responseData = await this.$http.submitAftersale(delData)
      if (responseData.status == 200) {
        this.$message({
          type: 'success',
          message: '操作成功!'
        });

        this.getDataList()
      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }

    },
    // 数据搜索
    searchData() {
      this.getRequestData.page = 1
      this.getDataList()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.getRequestData.page = val
      this.getDataList()
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getDataList()
    },

    // 获取数据列表
    async getDataList() {

      let responseData = await this.$http.queryAftersale(this.getRequestData)
      if (responseData && responseData.status == 200) {
        let resData = JSON.parse(JSON.stringify(responseData))
        this.returnData.list = resData.result.list
        this.returnData.pages = resData.result.pages
        this.returnData.total = resData.result.total
        this.returnData.pageNum = resData.result.pageNum

      } else {
        this.$message({
          message: responseData.message,
          type: 'error'
        });
      }
    },

    // 删除数据
    delDataAction() {
      if (this.returnData.list.length <= 0) {
        this.$message({
          message: '暂无数据',
          type: 'error'
        });
        return false
      }
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: "请至少选中一条操作数据",
          type: "error",
        });
        return false;
      }
      // if (this.multipleSelection[0].woamState != 0) {
      //     this.$message({
      //         message: "当前状态不可删除",
      //         type: "error",
      //     });
      //     return false;
      // }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        var delData = {
          ids: this.multipleSelection.map(item => item.wmId)
        }
        let responseData = await this.$http.deleteAftersale(delData)
        if (responseData.status == 200) {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });

          this.getDataList()
        } else {
          this.$message({
            message: responseData.message,
            type: 'error'
          });
        }

      }).catch(() => { });

    },
    //获取状态
    getIsGsp(str, val) {
      try {
        str && str.replace(/\\/g, '')
        let arr = JSON.parse(str)
        let len = arr.length
        let newStr = ''
        for (let i = 0; i < len; i++) {
          if (Number(arr[i].key) === val) {
            newStr = arr[i].value
            break;
          }
        }
        return newStr
      } catch (ex) {
        return str
      }
    },
    // 获取按钮权限
    async getButtonList() {
      this.buttonList = await this.$common.getActionButton()
      
    },
    initTime() {
      this.getRequestData.start = this.$common.getStartTime()
      this.getRequestData.end = this.$common.getEndTime()
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getPageInfo()
    this.initTime()
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped>
.table_content_tag {
  margin-right: 1rem;
}

.el-tabs--border-card_new {
  height: 85vh;
  overflow-y: scroll;
}
</style>
